import {AfterViewInit, Component, OnInit} from '@angular/core';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {Router} from '@angular/router';
import {FincasApiService} from '../../../../service/api/fincas-api.service';
import { StorageManager } from '../../../../common/storage-manager.class';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {RequestButtonTypes} from '../../../../common/components/request-button/request-button.component';
import {Utils} from '../../../../common/utils';
import {BaseView} from '../../../base-view';
import { Filtering } from 'src/app/service/filtering/filtering';

import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { SectoresEnvironmentDefinition } from './environment-variables';
import { SectoresFormDefinition } from './sector-form/form-definition';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';

@Component({
    selector: 'app-sectores',
    standalone: false,
    templateUrl: './sectores.component.html',
    styleUrls: ['./sectores.component.scss']
})
export class SectoresComponent extends BaseView<SectorModel> implements OnInit, AfterViewInit {
    /** Reactive form definition (initialized in `show()`). */
    public form!: SectoresFormDefinition;

    /** Environment/feature flags for this view. */
    public readonly env = new SectoresEnvironmentDefinition();
    
    public rol: string = StorageManager.getUser().rol;

    public filter: Filtering<SectorModel> = new Filtering<SectorModel>();
    
    public getRequest: RequestHandler<SectorModel[]> = this.fincasApi.sectoresGET;
    
    public deleteRequest: RequestHandler<SectorModel> = this.fincasApi.sectoresDELETE;
    
    public pathToForm = 'sectores-form';
    
    public menuItemId = 'sectores';


    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    
    public override model = {} as SectorModel;

    public btnAnadir = `Añadir ${this.env.sectorName}`;


    public cols: ColInterface[] = [
        {
            field: 'nombre', 
            header: 'Nombre', 
            filter: ''
        },
        {
            field: 'finca', 
            header: this.env.fincaName, 
            filter: ''
        },
        {
            field: 'partida', 
            header: 'Partida', 
            filter: '', 
            visible: this.env.showPartida
        },
        {
            field: 'goteros', 
            header: 'Nº Goteros/Árbol', 
            filter: '', 
            visible: this.env.appName !== 'gardengest'
        },
        {
            field: 'caudal_gotero', 
            header: 'Caudal Goteros (l/h)', 
            filter: '', 
            visible: this.env.appName !== 'gardengest'
        },
        {
            field: 'caudal_cuba', 
            header: 'Capacidad Cuba (l)', 
            filter: '', 
            visible: this.env.appName !== 'gardengest'
        },
        {
            field: 'caudal_inyectora', 
            header: 'Caudal Inyectora (l/h)', 
            filter: '', 
            visible: this.env.appName !== 'gardengest'
        },
        {
            field: 'sup_cultivada', 
            header: 'S.\xa0cultivada\xa0(' + this.env.textoSuperficie + ')', 
            footer: '', 
            visible: this.env.appName !== 'gardengest'
        },
        {
            field: 'total_plantas', 
            header: 'Nº\xa0Árboles/Plantas', 
            footer: '', 
            visible: this.env.appName !== 'gardengest'
        },
    ];

    constructor(public fincasApi: FincasApiService,
        private readonly dashboard: DashboardService,
        private readonly router: Router) {
        super(dashboard, fincasApi.sectoresGET, fincasApi.sectoresDELETE);
    }

    ngOnInit(): void {
        this.dashboard.setSubmenuItem('fincas', this.menuItemId);
    }

    ngAfterViewInit(): void {
        this.fincasApi.sectoresGET.response(() => {
            this.updateFooter();
        });
    }

    public add(): void {
        this.router.navigate(['dashboard', 'crear-sector']);
    }

    public edit(data: SectorModel): void {
        this.router.navigate(['dashboard', 'editar-sector', data.id]);
    }

    public override show(modal: string, data: SectorModel): void {
        super.show(modal, data);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        
        this.form = new SectoresFormDefinition(formType, data as Record<string, string>, null);
        
        Object.keys(this.model).forEach(key => {
            if (['goteros', 'caudal_cuba', 'caudal_inyectora'].includes(key)) {
                this.model[key] = Utils.decimalFormat(this.model[key]?.toString().replace(',', '.') ?? '');
            }
            if (['caudal_gotero', 'sup_cultivada'].includes(key)) {
                this.model[key] =
                    // TODO Cannot read property 'replace' of null ???
                     Utils.decimalFormat(this.model[key]?.toString()?.replace(',', '.') ?? '', 2); 
            }
            if (key === 'total_plantas') {
                const val = this.model[key]?.toString() ?? '';
                
                if (val.includes(',') || val.includes('.')) {
                    this.model[key] = val.replace(/[,\.].*$/, '');
                }
            }
        });
    }

    public override hide(modal: string): void {
        this.model = {} as SectorModel;
        
        this.canShow[modal] = false;
        
        this.deleteRequest.reset();
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (( Utils.isNumber(value) && col.field !== 'nombre') || 
            col.field === 'sup_cultivada') {
            return {
                textAlign: 'center',
                paddingRight: '40px'
            };
        }// if();

        return {textAlign: 'center'};
    }// ();

    public globalVisualTransform(value: string, col: { field: string; }): string {
        if (['caudal_gotero', 'sup_cultivada'].includes(col.field)) {
            return Utils.decimalFormat(value, 2);
        } else if (Utils.isNumber(value) && col.field !== 'finca') {
            return Utils.decimalFormat(value);
        }
        return value;
    }

    public override sum(field: string): void {
        let sum = 0;

        (this.filter.value || []).forEach(it => {
            sum += parseFloat(((it as SectorModel)[field]?.toString() ?? '') || '0');
        });
        
        this.cols.map(item => ({ ...item, footer: Utils.decimalFormat(sum + '', field === 'total_plantas' ? 0 : 2 ) }));
    }

    public override updateFooter(): void {
        ['sup_cultivada', 'total_plantas'].forEach(it => { this.sum(it); });
    }

    openDocumentInNewTab(): void {
        window.open('https://locatec.es/proyectos/fitogest/documentos_consulta/lista-de-cultivos-exentos-asesoramiento.pdf', '_blank');
    }
}
